import type { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { useCurrentUser } from "../domain/platform_core/auth/services/AuthService";
import { getHttpStatus } from "../shared/api/apiClient";
import ServerUnavailable from "../domain/platform_core/shell/components/ServerUnavailable";

///Schuetzt alle Routen unter /app.
export default function RequireAuth({ children }: { children: ReactNode }) {
  const { isPending, error, refetch, isFetching } = useCurrentUser(true);

  if (isPending) {
    return null;
  }

  if (error) {
    if (getHttpStatus(error) === 401) {
      return <Navigate to="/" replace />;
    }
    return (
      <ServerUnavailable
        onRetry={() => {
          void refetch();
        }}
        isRetrying={isFetching}
      />
    );
  }

  return <>{children}</>;
}
